import PropTypes from 'prop-types';
import React from 'react';

import AnimateString from '../common/AnimateString';
import Background from '../common/Background';
import CommonCTABtn from '../common/CommonCTABtn';

const CtaFooter = ({sectionClassName, data, mobile}) => {
  const {title, subtitle, subtitle2, leftImg, ctaConfig, bgImg, mobileBgImg} = data;
  const background = {type: 'object', desktopImage: bgImg, mobileImage: mobileBgImg};
  return (
    <div className="chapters-cta-footer">
      <Background className="ctaBackground" background={background}>
        <div className="cta-footer-content">
          {leftImg ? (
            <div className="left-section">
              <img src={leftImg} alt="charactor" />
            </div>
          ) : null}
          <div className={sectionClassName || 'right-section'}>
            {title ? (
              <AnimateString
                key="cta-footer-Title"
                text={title}
                type="h1"
                speed={1.5}
                delay={0.3}
                autoAlpha={0}
                yPos={100}
                minTop={20}
                scaleFrom={1}
                staggerDelay={0}
              />
            ) : null}
            {subtitle ? (
              <AnimateString
                key="cta-footer-subtitle"
                className="battle"
                text={!mobile ? subtitle : `${subtitle} ${subtitle2 || ''}`}
                type="h5"
                speed={1.5}
                delay={0.3}
                autoAlpha={0}
                yPos={100}
                minTop={20}
                scaleFrom={1}
                staggerDelay={0}
              />
            ) : null}
            {subtitle2 && !mobile ? (
              <AnimateString
                key="cta-footer-subtitle2"
                text={subtitle2}
                className="pass"
                type="h5"
                speed={1.5}
                delay={0.3}
                autoAlpha={0}
                yPos={100}
                minTop={20}
                scaleFrom={1}
                staggerDelay={0}
              />
            ) : null}
            <CommonCTABtn className="btn-hover-transform" ctaConfig={ctaConfig} />
          </div>
        </div>
      </Background>
    </div>
  );
};

CtaFooter.propTypes = {
  data: PropTypes.object,
  mobile: PropTypes.bool,
  sectionClassName: PropTypes.string,
};
export default CtaFooter;
